import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DripCampaignEditHeader from "./headers/drip-campaign-edit-header";
import DripCampaignEditName from "./drip-campaign-edit-name";
import DripCampaignEditContact from "./drip-campaign-edit-contact";
import DripCampaignEditCriteria from "./drip-campaign-edit-criteria";
import DripCampaignEditStages from "./stages/drip-campaign-edit-stages";
import DripCampaignEditLoader from "./drip-campaign-edit-loader";
import DripCampaignEditHeaderLoader from "./headers/drip-campaign-edit-header-loader";
import { GET_CAMPAIGN, GET_AUTOMATION, SUBMIT_CAMPAIGN_DETAILS, SUBMIT_TRIGGERS, SUBMIT_STAGES, SAVE_CURRENT_CAMPAIGN, TOGGLE_CURRENT_CAMPAIGN_ACTIVE } from "../store/drip-campaign-actions";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";
import { LOAD_MARKETING_EMAILS } from "@Broker/@Modules/marketing/store/marketing/marketing-actions";
import { mapState, mapActions } from "vuex";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import { isEmpty, isUndefined } from "lodash";
const validateTrigger = trigger => {
  var _trigger$metadata, _trigger$metadata2, _trigger$metadata3;
  if (trigger.deleted) return true;
  switch (trigger.type) {
    case "client-profile-created":
      return !!((_trigger$metadata = trigger.metadata) != null && _trigger$metadata.board);
    case "client-profile-status-changed":
      return !!((_trigger$metadata2 = trigger.metadata) != null && _trigger$metadata2.board) && !!((_trigger$metadata3 = trigger.metadata) != null && _trigger$metadata3.status);
  }
  return !!trigger.type;
};
const validateDaysToWait = (days, stage) => {
  if (stage.isFirst) return days >= 0;
  return days >= 1;
};
const emailIsVerified = value => {
  return isUndefined(value) || value;
};
import { defineComponent } from "@vue/composition-api";
import { validCanadianPostalCode } from "@Shared/@Utils/validation-rules";
export default defineComponent({
  name: "DripCampaignDetailsContainer",
  title() {
    return this.$t("sidebar.sections.dripCampaigns");
  },
  components: {
    DripCampaignEditHeader,
    DripCampaignEditName,
    DripCampaignEditContact,
    DripCampaignEditCriteria,
    DripCampaignEditStages,
    DripCampaignEditLoader,
    DripCampaignEditHeaderLoader
  },
  mixins: [validationMixin],
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  validations: {
    currentCampaign: {
      name: {
        required
      },
      fromName: {
        required
      },
      emailId: {
        required
      },
      emailVerified: {
        emailIsVerified
      },
      address: {
        city: {
          required
        },
        line1: {
          required
        },
        "street-number": {
          required
        },
        "street-name": {
          required
        },
        "postal-code": {
          required,
          validCanadianPostalCode
        },
        province: {
          required
        }
      },
      stages: {
        $each: {
          subject: {
            required
          },
          previewText: {
            required
          },
          timeToSendAt: {
            required
          },
          daysToWait: {
            required,
            numeric,
            validateDaysToWait
          },
          templateId: {
            required
          }
        }
      },
      triggers: {
        $each: {
          type: validateTrigger
        },
        atLeastOneEntryCriteria: function (triggers) {
          return !isEmpty(triggers) && !isEmpty(_filterInstanceProperty(triggers).call(triggers, trigger => trigger.type));
        },
        atLeastOneExitCriteria: function (triggers) {
          return !isEmpty(triggers) && !isEmpty(_filterInstanceProperty(triggers).call(triggers, trigger => !trigger.exit));
        }
      }
    }
  },
  data() {
    return {
      loading: {
        campaign: true,
        saving: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("DripCampaignStore", ["currentCampaign", "automation", "triggerMapper"])), {}, {
    isValid() {
      return !this.$v.$invalid;
    }
  }),
  activated() {
    if (!this.currentCampaign.fromTemplate) {
      this.getCampaign();
    } else {
      this.SAVE_CURRENT_CAMPAIGN({
        fromTemplate: false
      });
    }
    Amplitude.logEvent("Drip Campaigns - details visited");
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [GET_CAMPAIGN, GET_AUTOMATION, SUBMIT_CAMPAIGN_DETAILS, SUBMIT_TRIGGERS, SUBMIT_STAGES, SAVE_CURRENT_CAMPAIGN, TOGGLE_CURRENT_CAMPAIGN_ACTIVE])), mapActions("MarketingStore", [LOAD_MARKETING_EMAILS])), {}, {
    async handleSaveChanges() {
      this.loading.saving = true;
      const saveActions = [this.SUBMIT_CAMPAIGN_DETAILS(), this.SUBMIT_TRIGGERS(), this.SUBMIT_STAGES()];
      if (!this.currentCampaign.emailVerified && this.currentCampaign.active) {
        saveActions.push(this.TOGGLE_CURRENT_CAMPAIGN_ACTIVE());
        showToast("error", "emailMustBeVerifiedToActivateDripCampaign");
      }
      await _Promise.all(saveActions);
      this.getCampaign();
    },
    async getCampaign() {
      this.loading.campaign = true;
      await _Promise.all([this.GET_CAMPAIGN(this.campaignId), this.GET_AUTOMATION(), this.LOAD_MARKETING_EMAILS()]);
      this.loading.saving = false;
      this.loading.campaign = false;
    }
  })
});